/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Measure_Unit_Profile_OtherInputs */

const en_measure_unit_profile_other = /** @type {(inputs: Measure_Unit_Profile_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} profiles`)
};

const zh_hans1_measure_unit_profile_other = /** @type {(inputs: Measure_Unit_Profile_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个主页`)
};

const pt_br2_measure_unit_profile_other = /** @type {(inputs: Measure_Unit_Profile_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} perfis`)
};

const es_measure_unit_profile_other = /** @type {(inputs: Measure_Unit_Profile_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} perfiles`)
};

const fr_measure_unit_profile_other = /** @type {(inputs: Measure_Unit_Profile_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} profils`)
};

const de_measure_unit_profile_other = /** @type {(inputs: Measure_Unit_Profile_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Profile`)
};

const ru_measure_unit_profile_other = /** @type {(inputs: Measure_Unit_Profile_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Профилей: ${i?.count}`)
};

const it_measure_unit_profile_other = /** @type {(inputs: Measure_Unit_Profile_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} profili`)
};

/**
* | output |
* | --- |
* | "{count} profiles" |
*
* @param {Measure_Unit_Profile_OtherInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_profile_other = /** @type {((inputs: Measure_Unit_Profile_OtherInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Profile_OtherInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_profile_other(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_profile_other(inputs)
	if (locale === "es") return es_measure_unit_profile_other(inputs)
	if (locale === "fr") return fr_measure_unit_profile_other(inputs)
	if (locale === "de") return de_measure_unit_profile_other(inputs)
	if (locale === "ru") return ru_measure_unit_profile_other(inputs)
	if (locale === "it") return it_measure_unit_profile_other(inputs)
	return en_measure_unit_profile_other(inputs)
});